import { AppBar, Box, List, ListItemButton } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { motion } from "framer-motion";

// ─────────────────────────────
// Styled Components
// ─────────────────────────────

export const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "scrolled",
})(({ theme, scrolled }) => ({
  background: "#fff",
  color: theme.palette.text.primary,
  transition: "0.3s",
  boxShadow: scrolled ? "0 4px 20px rgba(0,0,0,0.08)" : "none",
  zIndex: theme.zIndex.modal + 1,
}));

export const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(0.5),
  direction: "rtl",
}));

export const Logo = styled("img", {
  shouldForwardProp: (prop) =>
    prop !== "isDesktop" && prop !== "scrolled" && prop !== "open",
})(({ theme, isDesktop, scrolled, open }) => ({
  width: scrolled ? 42 : 72,
  transition: "0.3s",
  display: open && !isDesktop && "none",
  [theme.breakpoints.down("sm")]: {
    width: scrolled ? 42 : 54,
  },
}));

export const SearchBox = styled(Box, {
  shouldForwardProp: (prop) => !["open", "scrolled"].includes(prop),
})(({ theme, open, scrolled }) => ({
  display: "flex",
  alignItems: "center",
  borderRadius: 999,
  background: alpha(theme.palette.grey[200], 0.7),
  padding: theme.spacing(0.5, 1.5),
  width: open ? 300 : scrolled ? 45 : 40,
  transition: "0.4s",
  overflow: open ? "visible" : "hidden",
  position: "relative",
}));

export const Dropdown = styled(motion.div)(({ theme }) => ({
  position: "absolute",
  top: "120%",
  right: 0,
  width: "100%",
  background: "#fff",
  borderRadius: 12,
  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
  padding: theme.spacing(1),
  zIndex: 10,
}));

export const NavList = styled(List, {
  shouldForwardProp: (prop) => prop !== "row",
})(({ row }) => ({
  display: row ? "flex" : "block",
  justifyContent: "center",
  flexDirection: row && "row-reverse",
  gap: row ? 32 : 4,
}));

export const NavButton = styled(ListItemButton)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
